<template>
  <div class="teachCenter courseEvaluat">
    <!--面包屑-->
    <div class="crumbs">
      <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
       <span>首页</span>>
      <span><router-link :to="{name:'TeachCenter'}">教学中心</router-link></span> >
      <span>课程查看</span>
    </div>
    <!--医学影像特征提取及应用-->
    <upper @ifShow="ifShow" @onShelf="onShelf"></upper>
    <!--评价-->
    <div v-show="assessShow" class="assess">
      <div class="outerLay">
        <div class="studentAssess">
          <div class="txtAssess">学员评价</div>
          <div v-show="notShow" class="txtBtn" @click="assessBtn">评价</div>
          <div v-show="alreadyEval" class="evald">我已评价</div>
        </div>
      </div>
      <!--评价列表-->
      <review ref="reviews"></review>
    </div>
    <!--评价弹框-->
    <pops v-if="assessPop" :show="assessPop" :title="''" @closePop="closePop" :width="'400px'">
       <div class="prompt">这节课有收获吗</div>
      <div class="block">
        <el-rate v-model="value1"  void-icon-class='el-icon-star-off'></el-rate>
      </div>
      <textarea v-model="comment" :maxlength="200" class="commentInput" placeholder="课程只能评价一次，请认真评价哦~" @keyup="commt"></textarea>
       <span class="areaLength"><b>{{areaLength}}</b>/200</span>
      <el-button type="primary" ref="publish" class="publish" @click="pubEvaluat">发表评价</el-button>
    </pops>
  </div>
</template>

<script type="text/ecmascript-6">
  import upper from '@/components/common/upper/upper'
  import review from '@/components/common/review/review'
  import pops from '@/components/common/pops/pop'
  import * as _ from '@/common/js/config'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import http from '@/api/http'
  import {message} from '@/common/js/messages'
  export default {
    components: {
      upper,
      review,
      pops
    },
    data() {
      return {
        assessPop: false,
        notShow: false,
        alreadyEval:false,
        comment: '',

        assessShow: true,
        value1:5,
        areaLength:'0'
      }
    },
    mounted() {
    },
    methods: {
      assessBtn() {
        this.assessPop = true
        this.value1 = 5
      },
      closePop() {
        this.assessPop = false
      },
      pubEvaluat() {
        this.$refs.publish.disabled = true
        let CourseId = getLocalStorage('Id')
        let params = {
          courseId: CourseId,
          starGrade: this.value1,
          content: this.comment
        }
        http.post('/studyCenter/evaluateCourse.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.assessPop = false
            message('评价成功', true)
            // this.$router.go(0)
            this.alreadyEval=true
            this.notShow=false
            this.$refs.reviews.evaltList();
          } else {
            this.$refs.publish.disabled = false
          }
        }).catch(err => {
        })
      },
      ifShow(val){
       // console.log(val,'===============')
        if(val===0){
          this.notShow = true
          this.alreadyEval = false
        } else {
          this.notShow = false
          this.alreadyEval = true
        }
      },
      onShelf(val){
        if(val==='2'){
         this.assessShow = true
        } else if(val==='1'){
          this.assessShow = false
        }
      },
      commt(){
        this.areaLength = this.comment.length.toString()

      }
    },
    created() {
      let Detail = getLocalStorage('detail')

    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .courseEvaluat
    .assess
      background: #fff
      margin-top: 15px
      .outerLay
        height: 50px
        border-bottom: 1px solid #cecaca
        .studentAssess
          width: calc(100% - 40px)
          margin: auto
          .txtAssess
            width: 80px
            height: 17px
            line-height: 17px
            position: relative
            top: 16px
            padding-left: 8px
            border-left: 4px solid $color-green
            color: #000
            float: left
            font-size: 15px
          .txtBtn
            float: right
            width: 100px
            text-align: center
            height: 30px
            line-height: 30px
            background: $color-green
            cursor: pointer
            position: relative
            top: 9px
            color: #fff
          .evald
            float: right
            position: relative
            top: 9px
            text-align: center
            width: 100px
            line-height: 30px
            color:$color-green
  .prompt
    margin: 20px auto
    text-align: center
    font-size: 16px
    color: #000
  .commentInput
    position realative
    width: 100% !important
    height: 200px !important
    border: 1px solid #d0cdcd
    overflow-y:auto
    padding: 10px
    color: #000
    resize:none
    box-sizing: border-box
  .areaLength
    position absolute
    padding:3px 4px
    background:#fff
    right:21px
    bottom:66px
    color $color-maingrey
    b
      color $color-green
  .publish
    width: 160px
    background: $color-green
    height: 35px
    text-align: center
    color: #fff
    margin-top: 15px
    margin-left: 100px
    cursor: pointer
  .block
    text-align: center
    margin: 0 auto 30px
</style>



// WEBPACK FOOTER //
// courseEvaluat.vue?425438f2